import type { NavigateFunction } from 'react-router-dom'

/**
 * Schickt zur Anmeldung und merkt sich, wohin es danach zurueckgeht (Plan API 2026-10-10/06 S2, KW-005, E14).
 *
 * `ziel` ist ein app-interner Pfad samt Abfrage, wie ihn die Annahmeseiten aus core-frontend uebergeben
 * (`/invite/accept?token=…`, `/ownership-transfer/accept?token=…`). Er reist als `state.from` — die app-eigene
 * `LoginPage` liest genau das (nach der Anmeldung und bei bestehender Sitzung). Kein Wert aus der URL wird
 * gelesen, also gibt es keinen offenen Redirect (Vorbild HV `UserTokenPages.tsx`).
 *
 * Zeigt `ziel` selbst auf `/login` (Sackgasse der Annahmeseite), geht es ohne `state` zur Anmeldung — sonst
 * fuehrte die Anmeldung zurueck auf `/login` (Schleife). Die Anmeldung landet dann auf `defaultRoute`.
 *
 * ⚪ Beim vollen Neuladen von `/login` geht `state` verloren; die Anmeldung landet dann ebenfalls auf
 * `defaultRoute`, die Annahmeseite bietet „Log in“ erneut an (Abwaegung E14).
 */
export function zurAnmeldung(navigate: NavigateFunction, ziel: string): void {
  const pfad = ziel.split(/[?#]/, 1)[0]
  if (pfad === '/login') {
    navigate('/login')
    return
  }
  navigate('/login', { state: { from: { pathname: ziel } } })
}
